<template>
  <div id="roc" class="mb-5">
    <ReportHeader
      :reportTypeId="reportTypeId"
      :title="title"
      :subtitle="subtitle"
    />
    <div class="row">
      <div class="col-xx-large-9 col-x-large-8 pb-3">
        <div id="rocChart"></div>
        <div style="display: none">
          <img id="rocChartImg" src="" />
        </div>
      </div>
      <div class="col-xx-large-3 col-x-large-4 pb-3">
        <div class="row">
          <div class="col-x-large-12 col-large-6 pb-3">
            <label
              class="text-center divisionPhase"
              :style="
                rocData.Phase === 'A'
                  ? 'background: #0A42D3;'
                  : rocData.Phase === 'B'
                    ? 'background: #44AC4E;'
                    : rocData.Phase === 'C'
                      ? 'background: #FF9916;'
                      : rocData.Phase === 'D'
                        ? 'background: #D2232A;'
                        : 'background: #A7A9AB;'
              "
            >
              Current Phase
            </label>
            <div class="row no-gutters rocPhaseWrapper">
              <div class="col">
                <div
                  class="px-1 py-2"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <img
                    :id="'divisionPhaseImage' + rowNumber"
                    class="img-fluid py-2"
                    style="width: 70px"
                    :src="
                      rocData.Phase === 'A'
                        ? '/images/phase-a.png'
                        : rocData.Phase === 'B'
                          ? '/images/phase-b.png'
                          : rocData.Phase === 'C'
                            ? '/images/phase-c.png'
                            : rocData.Phase === 'D'
                              ? '/images/phase-d.png'
                              : '/images/phase-na.png'
                    "
                  />
                  <div class="px-2">
                    <label style="margin-bottom: 0px">
                      Phase {{ rocData.Phase }}
                    </label>
                    <label>{{ rocData.PhaseTitle }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-x-large-12 col-large-6 text-center pb-3">
            <label
              class="rocCardLabel"
              :style="
                swap ? 'background: #183961;' : 'background: #65A9D2;'
              "
            >
              Quarterly Growth (3/12)
            </label>
            <p
              class="p-4 rocCardP"
              :style="swap ? 'color: #183961;' : 'color: #65A9D2;'"
            >
              {{ rocData.Last312 }}
            </p>
          </div>
          <div class="col-x-large-12 col-large-6 text-center pb-3">
            <label
              class="rocCardLabel"
              :style="
                swap ? 'background: #65A9D2;' : 'background: #183961;'
              "
            >
              Annual Growth (12/12)
            </label>
            <p
              class="p-4 rocCardP"
              :style="swap ? 'color: #65A9D2;' : 'color: #183961;'"
            >
              {{ rocData.Last1212 }}
            </p>
          </div>
          <div class="col-x-large-12 col-large-6 text-center pb-3">
            <label class="rocCardLabel" style="background: #183961">
              {{ rocData.FirstTurningPointLabel }}
            </label>
            <p class="p-4 rocCardP" style="color: #183961">
              {{ rocData.FirstTurningPointQ }}
            </p>
          </div>
          <div class="col text-center pb-3">
            <label class="rocCardLabel" style="background: #183961">
              {{ rocData.SecondTurningPointLabel }}
            </label>
            <p class="p-4 rocCardP" style="color: #183961">
              {{ rocData.SecondTurningPointQ }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="consulting_slug !== 'timing-model'">
      <div class="row">
        <div class="col">
          <div class="table-responsive">
            <table id="rocTable" class="table text-center">
              <thead>
                <tr>
                  <th
                    class="tableHeader dataTrendsTableHeaderLeft dataTrendsTableHeaderRight"
                  ></th>
                  <th
                    class="tableHeader dataTrendsTableHeaderLeft dataTrendsTableHeaderRight"
                    v-for="(row, index) in rocData.RoCDetailTable.Columns"
                    v-bind:key="index"
                  >
                    {{ row.MonthYear }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="rowTitle">
                    {{ rocData.RoCDetailTable.Row2Title }}
                  </td>
                  <td
                    class="text-center"
                    v-for="(row, index) in rocData.RoCDetailTable.Columns"
                    v-bind:key="index"
                  >
                    {{ row.LMR }}
                  </td>
                </tr>
                <tr>
                  <td class="rowTitle">
                    {{ rocData.RoCDetailTable.Row3Title }}
                  </td>
                  <td
                    class="text-center"
                    v-for="(row, index) in rocData.RoCDetailTable.Columns"
                    v-bind:key="index"
                  >
                    {{ row.Median }}
                  </td>
                </tr>
                <tr>
                  <td class="rowTitle">
                    {{ rocData.RoCDetailTable.Row4Title }}
                  </td>
                  <td
                    class="text-center"
                    v-for="(row, index) in rocData.RoCDetailTable.Columns"
                    v-bind:key="index"
                  >
                    {{ row.UMR }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ReportHeader from '~/components/report/ReportHeader.vue';
  export default {
    name: 'ROCComponent',
    components: {
      ReportHeader,
    },
    props: {
      rocData: Object,
      companyLogo: String,
      companyName: String,
      consulting_slug: String,
      rowNumber: Number,
      swap: {
        default: false,
        type: Boolean,
      },
      reportTypeId: {
        type: [String, Number],
        // required: true,
      },
    },
    data() {
      return {
        firstLoad: true,
        monthYear: [],
      };
    },
    computed: {
      title() {
        return `Rates-of-Change for ${this.companyName}`;
      },
      subtitle() {
        return ``;
      },
    },
    mounted() {
      this.plotChart(true);
      this.$emit('rocLoaded');
    },
    methods: {
      async pushToImage(w = 800, h = 600) {
        // await this.plotChart().then( async () => {
        return await Plotly.toImage('rocChart', {
          format: 'png',
          width: w,
          height: h,
        });
      },
      plotChart: function (firstLoad) {
        this.firstLoad = firstLoad;
        if (!this.firstLoad) {
          document
            .getElementById('rocChart')
            .classList.contains('js-plotly-plot')
            ? document
                .getElementById('rocChart')
                .classList.remove('js-plotly-plot')
            : '';
          document.getElementById('rocChart').innerHTML = '';
        }

        this.monthYear = [];
        for (let i = 0; i < this.rocData.MonthYear.length; i++) {
          var date = this.rocData.MonthYear[i];
          if (this.firstLoad && this.rocData.DataShift != 0) {
            var newDate = new Date(date);
            var year = newDate.getFullYear();
            this.monthYear.push(
              new Date(
                year + this.rocData.DataShift,
                newDate.getMonth(),
                newDate.getDate()
              )
            );
          } else {
            this.monthYear.push(date);
          }
        }

        var fyTickSettings = '';
        if (this.firstLoad && this.rocData.DataShift != 0) {
          var tmpSettings = this.rocData.FiscalYearTickSetting;
          var tmpYear =
            parseInt(tmpSettings.slice(0, 4)) + this.rocData.DataShift;
          fyTickSettings = tmpYear + tmpSettings.slice(4, tmpSettings.length);
        } else {
          fyTickSettings = this.rocData.FiscalYearTickSetting;
        }

        let qTrace = {
          type: 'scatter',
          mode: 'scatter',
          x: this.monthYear,
          y: this.rocData.ThreeTwelve,
          name: this.swap
            ? this.rocData.DataType + ' - 12/12'
            : this.rocData.DataType + ' - 3/12',
          line: {
            width: 4,
            color: '#65A9D2',
          },
          yaxis: 'y1',
          xaxis: 'x',
          visible: true,
        };

        let aTrace = {
          type: 'scatter',
          mode: 'scatter',
          x: this.monthYear,
          y: this.rocData.TwelveTwelve,
          name: this.swap
            ? this.rocData.DataType + ' - 3/12'
            : this.rocData.DataType + ' - 12/12',
          line: {
            width: 4,
            color: '#183961',
          },
          yaxis: 'y2',
          xaxis: 'x',
          visible: true,
        };

        let forecastLMRTrace = {
          mode: 'lines',
          name: this.swap
            ? this.rocData.DataType + ' Forecast - 3/12'
            : this.rocData.DataType + ' Forecast - 12/12',
          legendgroup: this.swap
            ? this.rocData.DataType + ' Forecast -3/12'
            : this.rocData.DataType + ' Forecast - 12/12',
          showlegend: false,
          x: this.monthYear,
          y: this.rocData.ForecastLMR,
          line: {
            color: '#183961',
            width: 4,
            dash: 'dashdot',
          },
          yaxis: 'y2',
          xaxis: 'x',
          visible: false,
        };

        let forecastUMRTrace = {
          type: 'scatter',
          mode: 'lines',
          name: this.swap
            ? this.rocData.DataType + ' Forecast - 3/12'
            : this.rocData.DataType + ' Forecast - 12/12',
          legendgroup: this.swap
            ? this.rocData.DataType + ' Forecast - 3/12'
            : this.rocData.DataType + ' Forecast - 12/12',
          showlegend: false,
          x: this.monthYear,
          y: this.rocData.ForecastUMR,
          line: {
            color: '#183961',
            width: 4,
            dash: 'dashdot',
          },
          yaxis: 'y2',
          xaxis: 'x',
          visible: false,
        };

        // var decimalPoint = 1;
        for (let i = 0; i < this.monthYear.length; ++i) {
          if (this.rocData.ForecastLMR[i]) {
            forecastLMRTrace.showlegend = true;
            forecastLMRTrace.visible = true;
          }

          if (this.rocData.ForecastUMR[i]) {
            forecastUMRTrace.visible = true;
          }
        }

        let chartData = [aTrace, forecastLMRTrace, forecastUMRTrace, qTrace];

        //layout options
        const layout = {
          showlegend: true,
          autosize: true,
          legend: {
            orientation: 'h',
            y: 1.0596774193548388,
            x: 0.5,
            xanchor: 'center',
            yanchor: 'middle',
            valign: 'middle',
            traceorder: 'normal',
            bgcolor: '#fff',
            bordercolor: '#444',
            borderwidth: 0,
            font: {
              family: '\\"Open Sans\\", sans-serif',
            },
          },
          modebar: {
            orientation: 'v',
          },
          dragmode: 'zoom',
          yaxis: {
            title: '3/12',
            mirror: true,
            overlaying: 'y2',
            anchor: 'x',
            family: '\\"Open Sans\\", sans-serif',
            size: 12,
            color: '#444',
            ticks: 'outside',
            automargin: true,
            showline: false,
            // tickformat: `.${decimalPoint}f`,
          },
          yaxis2: {
            title: '12/12',
            showgrid: false,
            anchor: 'x',
            side: 'right',
            family: '\\"Open Sans\\", sans-serif',
            size: 12,
            color: '#444',
            ticks: 'outside',
            zeroline: false,
            automargin: true,
            // tickformat: `.${decimalPoint}f`,
          },
          xaxis: {
            // title: "Years",
            dtick: 'M24',
            ticks: 'outside',
            automargin: true,
            showline: true,
            showgrid: false,
            tick0: fyTickSettings,
            tickformat: '%Y',
            hoverformat: '%b %Y',
          },
          family: '\\"Open Sans\\", sans-serif',
          size: 12,
          color: '#444',
          height: 600,
          margin: {
            t: 50,
            l: 50,
            r: 50,
            b: 50,
          },
        };

        if (this.swap) {
          layout.yaxis.title = '12/12';
          layout.yaxis2.title = '3/12';
        }

        Plotly.react('rocChart', chartData, layout, {
          responsive: true,
          displaylogo: false,
          modeBarButtonsToRemove: [
            'autoScale2d',
            'toImage',
            'sendDataToCloud',
            'lasso2d',
            'toggleSpikelines',
            'resetScale2d',
          ],
          doubleClick: false /*'reset'*/,
        }).then((chartData) => {
          this.adjustChart(chartData);
          document
            .getElementById('rocChart')
            .on('plotly_relayout', (eventData) => {
              this.adjustChart(document.getElementById('rocChart'), eventData);
            });
        });
      },
      adjustChart: function (chartData = null, eventData = null) {
        const axisZoomedIn =
          eventData !== null && eventData['xaxis.range[0]'] ? true : false;
        let layoutObject = this.getTableRanges(
          chartData,
          axisZoomedIn,
          eventData
        );

        if (axisZoomedIn) {
          layoutObject['xaxis.range'] = chartData.layout.xaxis.range;
          layoutObject['xaxis.dtick'] = 'M12';
        } else {
          layoutObject['xaxis.range'] = [
            this.monthYear[0],
            this.monthYear[this.monthYear.length - 1],
          ];
          layoutObject['xaxis.dtick'] = 'M24';
        }

        Plotly.update('rocChart', null, layoutObject).then(() => {
          var dataShift = this.rocData.DataShift;
          if (dataShift !== 0) {
            Plotly.d3.selectAll('#rocChart .xtick text').each(function (d, i) {
              var x = Plotly.d3.select(this).html();
              if (x.length > 0) {
                var date = parseInt(x);
                Plotly.d3.select(this).html(date + dataShift);
              }
            });
          }

          // img for exports
          if ($('#rocChartImg').attr('src') === '') {
            Plotly.toImage(chartData, { height: 600, width: 800 }).then(
              (url) => {
                $('#rocChartImg').attr('src', url);
                this.firstLoad = false;
                this.plotChart(false);
              }
            );
          }
        });
      },
      getTableRanges: function (
        chartObject = [],
        axisZoomedIn = false,
        axisEventObject = [],
        matchTraces = false
      ) {
        const rows = chartObject.data;
        let y1Axis = rows.filter((row) => {
          if (
            row !== undefined &&
            row.y.length > 0 &&
            row.yaxis === 'y' &&
            row.visible
          ) {
            return row;
          }
        });

        var y1AllMin = y1Axis.map((row) => {
          const min = Math.min.apply(
            Math,
            row.y.filter((o) => {
              if (o !== '') {
                return parseFloat(o);
              }
            })
          );

          if (min !== undefined) {
            return min;
          }
        });

        var y1AllMax = y1Axis.map((row) => {
          const max = Math.max.apply(
            Math,
            row.y.filter((o) => {
              if (o !== '') {
                return parseFloat(o);
              }
            })
          );

          if (max !== undefined) {
            return max;
          }
        });

        let y1_min = Math.min.apply(
          Math,
          y1AllMin.filter(function (o) {
            if (o !== '') {
              return parseFloat(o);
            }
          })
        );

        let y1_max = Math.max.apply(
          Math,
          y1AllMax.filter(function (o) {
            if (o !== '') {
              return parseFloat(o);
            }
          })
        );

        let y2Axis = rows.filter((row) => {
          if (
            row !== undefined &&
            row.y.length > 0 &&
            row.yaxis === 'y2' &&
            row.visible
          ) {
            return row;
          }
        });

        var y2AllMin = y2Axis.map((row) => {
          const min = Math.min.apply(
            Math,
            row.y.filter((o) => {
              if (o !== '' && o !== Infinity && o !== -Infinity) {
                return parseFloat(o);
              } else {
                return -1;
              }
            })
          );

          if (min !== undefined) {
            return min;
          }
        });

        var y2AllMax = y2Axis.map((row) => {
          const max = Math.max.apply(
            Math,
            row.y.filter((o) => {
              if (o !== '') {
                return parseFloat(o);
              }
            })
          );

          if (max !== undefined) {
            return max;
          }
        });

        let y2_min;
        let y2_max;

        if (y2AllMin.length > 0) {
          y2_min = Math.min.apply(
            Math,
            y2AllMin.filter(function (o) {
              if (o !== '') {
                return parseFloat(o);
              }
            })
          );
        } else {
          y2_min = y1_min;
        }

        if (y2AllMax.length > 0) {
          y2_max = Math.max.apply(
            Math,
            y2AllMax.filter(function (o) {
              if (o !== '') {
                return parseFloat(o);
              }
            })
          );
        } else {
          y2_max = y1_max;
        }

        if (y2_min === Infinity || y2_min === -Infinity) {
          y2_min = -1;
        }

        if (y2_max === Infinity || y2_max === -Infinity) {
          y2_max = 1;
        }

        // if (y2_min < 0 && y2_min > -1) {
        //     y2_min = -1;
        // }

        // if (y2_max > -1 && y2_max < 1) {
        //     y2_max = 1;
        // }

        if (matchTraces) {
          if (y1_min < y2_min) {
            y2_min = y1_min;
          } else {
            y1_min = y2_min;
          }

          if (y1_max > y2_max) {
            y2_max = y1_max;
          } else {
            y1_max = y2_max;
          }
        }

        if (axisZoomedIn) {
          if (axisEventObject['yaxis.range[0]']) {
            y1_min = axisEventObject['yaxis.range[0]'];
          }

          if (axisEventObject['yaxis.range[1]']) {
            y1_max = axisEventObject['yaxis.range[1]'];
          }

          if (axisEventObject['yaxis2.range[0]']) {
            y2_min = axisEventObject['yaxis2.range[0]'];
          }

          if (axisEventObject['yaxis2.range[1]']) {
            y2_max = axisEventObject['yaxis2.range[1]'];
          }
        } else {
          //build dynamic range based on API response
          //build dynamic range based on API response
          if (this.rocData.MinY1 !== 0) {
            //overrides from CWA
            y1_min = this.rocData.MinY1 - 1;
          } else if (this.rocData.GraphMinRange !== 0) {
            //see if default left axis was set in NGB
            y1_min = this.rocData.GraphMinRange - 1;
          }

          if (this.rocData.MaxY1 !== 0) {
            //overrides from CWA
            y1_max = this.rocData.MaxY1 + 1;
          } else if (this.rocData.GraphMaxRange !== 0) {
            //see if default left axis was set in NGB
            y1_max = this.rocData.GraphMaxRange + 1;
          }

          if (this.rocData.MinY2 !== 0) {
            y2_min = this.rocData.MinY2 - 1;
          } else {
            if (y1_min > y2_min) {
              y1_min = y2_min;
            } else {
              y2_min = y1_min;
            }
          }

          if (this.rocData.MaxY2 !== 0) {
            y2_max = this.rocData.MaxY2 + 1;
          } else {
            if (y1_max < y2_max) {
              y1_max = y2_max;
            } else {
              y2_max = y1_max;
            }
          }
        }

        y1_min = Math.round(y1_min);
        y1_max = Math.round(y1_max);
        y2_min = Math.round(y2_min);
        y2_max = Math.round(y2_max);
        // const ticks = this.getTicks(y1_min, y1_max, y2_min, y2_max);
        return {
          // 'yaxis.range': ticks.y1Range,
          // 'yaxis2.range': ticks.y2Range,
          'yaxis.range': [y1_min, y1_max],
          'yaxis2.range': [y2_min, y2_max],
          // 'yaxis.dtick': ticks.y1dTick,
          // 'yaxis2.dtick': ticks.y2dTick,
          // 'xaxis.range': []
        };
      },
      getTicks: function (y1_min, y1_max, y2_min, y2_max) {
        const GRIDLINES = 5;

        var y1_range;
        if (y1_min < 0) {
          y1_range = y1_max - y1_min;
        } else {
          y1_range = y1_max;
        }

        y1_range = y1_range * 1000; // mult by 1000 to account for ranges < 1
        let y1_len = Math.floor(y1_range).toString().length;

        let y1_pow10_divisor = Math.pow(10, y1_len - 1);
        let y1_firstdigit = Math.floor(y1_range / y1_pow10_divisor);
        let y1_max_base = (y1_pow10_divisor * y1_firstdigit) / 1000; // div by 1000 to account for ranges < 1

        let y1_dtick = y1_max_base / GRIDLINES;

        y1_pow10_divisor = Math.pow(10, y1_len - 1) / 1000; // reset for logging purposes
        y1_range = y1_range / 1000; // range reset

        var y2_range;
        if (y2_min < 0) {
          y2_range = y2_max - y2_min;
        } else {
          y2_range = y2_max;
        }

        y2_range = y2_range * 1000; // mult by 1000 to account for ranges < 1
        let y2_len = Math.floor(y2_range).toString().length;

        let y2_pow10_divisor = Math.pow(10, y2_len - 1);
        let y2_firstdigit = Math.floor(y2_range / y2_pow10_divisor);
        let y2_max_base = (y2_pow10_divisor * y2_firstdigit) / 1000; // div by 1000 to account for ranges < 1

        let y2_dtick = y2_max_base / GRIDLINES;

        y2_pow10_divisor = Math.pow(10, y2_len - 1) / 1000; // reset for logging purposes
        y2_range = y2_range / 1000; // range reset

        /**************************************************************************/
        // Capture the highest dtick ratio as your global dtick ratio.
        //
        // All other axes will have their positive and negative ranges scaled to
        // make their dtick_ratios match the global ratio. When the ratios match,
        // the gridlines match!
        /**************************************************************************/

        var y1_dtick_ratio = Math.round(y1_range / y1_dtick);
        var y2_dtick_ratio = Math.round(y2_range / y2_dtick);

        var global_dtick_ratio = Math.round(
          Math.max(y1_dtick_ratio, y2_dtick_ratio)
        );

        /**************************************************************************/
        // Calculate Range Minimums
        //
        // 1. This is done by first finding the negative ratio for all axes:
        //     1. what percentage of the range is coming from negative values
        //     2. multiply percentage by global ratio to get the percentage of the
        //        global ratio (percentage of total gridlines) that should be shown
        //        under the zero baseline.
        //
        //     NEGATIVE RATIO == NUMBER OF GRIDLINES NEEDED FOR NEGATIVE VALUES
        //
        // 2. Capturing the highest negative ratio as the global negative ratio
        //
        // 3. Then applying the negative ratio to all of your axis minimumsto get
        //    their new proportionally scaled range minimums
        /**************************************************************************/

        var negative = false; // Are there any negative values present
        var y1_negative_ratio;
        if (y1_min < 0) {
          negative = true;
          y1_negative_ratio = Math.abs(y1_min / y1_range) * global_dtick_ratio;
        } else {
          y1_negative_ratio = 0;
        }

        var y2_negative_ratio;
        if (y2_min < 0) {
          negative = true;
          y2_negative_ratio = Math.abs(y2_min / y2_range) * global_dtick_ratio;
        } else {
          y2_negative_ratio = 0;
        }

        // Increase the ratio by 0.1 so that your range minimums are extended just
        // far enough to not cut off any part of your lowest value
        var global_negative_ratio =
          Math.max(y1_negative_ratio, y2_negative_ratio) + 0.1;

        // If any negative value is present, you must proportionally extend the
        // range minimum of all axes
        var y1_range_min;
        var y2_range_min;
        if (negative) {
          y1_range_min = global_negative_ratio * y1_dtick * -1;
          y2_range_min = global_negative_ratio * y2_dtick * -1;
        } else {
          // If no negatives, baseline is set to zero
          y1_range_min = 0;
          y2_range_min = 0;
        }

        // ************************************************************************
        // Calculate Range Maximums
        //
        // 1. This is done by first finding the positive ratio for all axes:
        //     1. what percentage of the range is coming from positive values
        //     2. multiply percentage by global ratio to get the percentage of the
        //        global ratio (percentage of total gridlines) that should be shown
        //        above the zero baseline.
        //
        //     POSITIVE RATIO == NUMBER OF GRIDLINES NEEDED FOR POSITIVE VALUES
        //
        // 2. Capturing the highest positive ratio as the global positive ratio
        //
        // 3. Then applying the positive ratio to all of your axis maximums to get
        //    their new proportionally scaled range maximums
        /**************************************************************************/

        var y1_positive_ratio =
          Math.abs(y1_max / y1_range) * global_dtick_ratio;
        var y2_positive_ratio =
          Math.abs(y2_max / y2_range) * global_dtick_ratio;

        // Increase the ratio by 0.1 so that your range maximums are extended just
        // far enough to not cut off any part of your highest value
        var global_positive_ratio =
          Math.max(y1_positive_ratio, y2_positive_ratio) + 0.1;

        var y1_range_max = global_positive_ratio * y1_dtick;
        var y2_range_max = global_positive_ratio * y2_dtick;

        return {
          y1Range: [y1_range_min, y1_range_max],
          y1dTick: y1_dtick,
          y2Range: [y2_range_min, y2_range_max],
          y2dTick: y2_dtick,
        };
      },
    },
  };
</script>
